(() => {
  const KS_WA = 'https://wa.me/918344333729?text=Hi%20KS%20Textiles%2C%20I%20need%20help%20choosing%20a%20saree.';

  function findSectionByText(text) {
    const needle = String(text || '').toLowerCase();
    return [...document.querySelectorAll('#MainContent .shopify-section')].find((section) =>
      (section.textContent || '').toLowerCase().includes(needle)
    );
  }

  function hideDemoSections() {
    ['Example product title', 'CARE FOR YOUR SKIN', 'Made for sensitive skin'].forEach((text) => {
      const section = findSectionByText(text);
      if (section) section.style.display = 'none';
    });
  }

  function buildCollectionShop(collectionSection) {
    if (!collectionSection || document.getElementById('KSCollectionShop')) return;

    const section = document.createElement('section');
    section.id = 'KSCollectionShop';
    section.className = 'ks-weaves';
    section.setAttribute('aria-labelledby', 'KSCollectionHeading');
    section.innerHTML = `
      <div class="page-width ks-weaves__inner">
        <div class="ks-weaves__header">
          <span class="ks-section-eyebrow">EXPLORE KS TEXTILES</span>
          <h2 id="KSCollectionHeading">Shop by Collection</h2>
          <p>Explore our core saree collections — from Kanchi Pattu and soft silks to easy-drape borderless styles. New collections will join the edit as KS grows.</p>
        </div>
        <div class="ks-weaves__track" role="list">
          <a class="ks-weave-card" role="listitem" href="/collections/premium-soft-silk-saree">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0831/8051/9683/files/WhatsAppImage2026-07-31at5.13.06PM_3.jpg?v=1785511722" alt="Premium Soft Silks at KS Textiles">
            <span class="ks-weave-card__shade"></span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__kicker">SOFT SILKS</span><strong>Premium Soft Silks</strong><small>Rich colour. Easy drape.</small></span>
          </a>
          <a class="ks-weave-card" role="listitem" href="/collections/kanjivaram-saree">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0831/8051/9683/files/IMG20260731123046.jpg_resized.jpg?v=1785492548" alt="Kanchi Pattu Sarees at KS Textiles">
            <span class="ks-weave-card__shade"></span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__kicker">CELEBRATION SILKS</span><strong>Kanchi Pattu Sarees</strong><small>Classic borders. Festive presence.</small></span>
          </a>
          <a class="ks-weave-card" role="listitem" href="/collections/borderless-soft-silk-sarees">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0831/8051/9683/files/rn-image_picker_lib_temp_0e193c3f-b95c-4392-9e79-63fcf50afc36.jpg?v=1785507640" alt="Borderless Soft Silks at KS Textiles">
            <span class="ks-weave-card__shade"></span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__kicker">LIGHT &amp; VERSATILE</span><strong>Borderless Soft Silks</strong><small>Clean finish. Easy elegance.</small></span>
          </a>
          <a class="ks-weave-card" role="listitem" href="/collections/art-silk-sarees">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0831/8051/9683/collections/ChatGPT_Image_Jul_22_2026_11_48_34_AM_6.png?v=1784901951" alt="Art Silk Sarees at KS Textiles">
            <span class="ks-weave-card__shade"></span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__kicker">EVERYDAY FESTIVE</span><strong>Art Silk Sarees</strong><small>Colourful. Versatile. Easy to wear.</small></span>
          </a>
          <a class="ks-weave-card ks-weave-card--soon" role="listitem" href="/collections/kanchi-soft-silk-sarees">
            <span class="ks-weave-card__monogram">KS</span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__badge">COMING SOON</span><strong>Kanchi Soft Silks</strong><small>A new KS collection in progress.</small></span>
          </a>
          <a class="ks-weave-card ks-weave-card--soon" role="listitem" href="/collections/kanchi-silk-cotton-sarees">
            <span class="ks-weave-card__monogram">KS</span>
            <span class="ks-weave-card__content"><span class="ks-weave-card__badge">COMING SOON</span><strong>Kanchi Silk Cotton</strong><small>A new KS collection in progress.</small></span>
          </a>
        </div>
      </div>`;

    collectionSection.parentNode.insertBefore(section, collectionSection);
    collectionSection.style.display = 'none';
  }

  function buildAssistedShopping(faqSection) {
    if (!faqSection || document.getElementById('KSAssistedShopping')) return;
    const band = document.createElement('section');
    band.id = 'KSAssistedShopping';
    band.className = 'ks-assisted-shopping';
    band.innerHTML = `
      <div class="page-width ks-assisted-shopping__inner">
        <div>
          <span class="ks-assisted-shopping__eyebrow">PERSONAL SAREE ASSISTANCE</span>
          <h2>Need help choosing a saree?</h2>
          <p>Tell us the occasion, budget and colours you like. We’ll help you shortlist on WhatsApp.</p>
        </div>
        <a class="ks-assisted-shopping__button" href="${KS_WA}" target="_blank" rel="noopener noreferrer">Chat with KS</a>
      </div>`;
    faqSection.parentNode.insertBefore(band, faqSection);
  }

  function restoreOldReviews() {
    const reviews = findSectionByText('Customer Feedback');
    if (reviews) reviews.style.display = '';
    const placeholder = document.getElementById('KSCustomerStories');
    if (placeholder) placeholder.remove();
  }

  function iconSvg(name) {
    const common = 'viewBox="0 0 24 24" aria-hidden="true" focusable="false"';
    const icons = {
      home: `<svg ${common}><path d="M3.5 10.6 12 3.5l8.5 7.1v9.2a.7.7 0 0 1-.7.7h-5.1v-6h-5.4v6H4.2a.7.7 0 0 1-.7-.7z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>`,
      collections: `<svg ${common}><rect x="4" y="4" width="7" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="4" width="7" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="4" y="13" width="7" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="13" width="7" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>`,
      account: `<svg ${common}><circle cx="12" cy="8" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M5.6 20c.5-4 2.6-6.2 6.4-6.2s5.9 2.2 6.4 6.2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`,
      cart: `<svg ${common}><path d="M3.5 5h2l1.7 9.1a1.4 1.4 0 0 0 1.4 1.1h8.6a1.4 1.4 0 0 0 1.3-1l1.7-6.2H6.1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19" r="1.2"/><circle cx="17.5" cy="19" r="1.2"/></svg>`,
      whatsapp: `<svg ${common}><path fill="currentColor" d="M12.05 2.5a9.2 9.2 0 0 0-7.78 14.1L3 21.5l5.02-1.32a9.18 9.18 0 1 0 4.03-17.68Zm0 16.72a7.54 7.54 0 0 1-3.84-1.05l-.28-.17-2.98.78.8-2.9-.19-.3a7.52 7.52 0 1 1 6.49 3.64Zm4.13-5.63c-.23-.11-1.34-.66-1.55-.74-.2-.08-.35-.11-.5.12-.14.23-.57.74-.7.9-.13.15-.26.17-.49.06-.22-.11-.94-.35-1.8-1.11-.66-.59-1.11-1.32-1.24-1.54-.13-.23-.01-.35.1-.46.1-.1.22-.26.34-.4.11-.13.15-.22.22-.37.08-.15.04-.28-.02-.4-.05-.11-.5-1.2-.68-1.65-.18-.43-.36-.37-.5-.38h-.42c-.15 0-.4.06-.6.28-.2.23-.79.77-.79 1.88s.81 2.18.92 2.33c.11.15 1.59 2.43 3.85 3.41.54.23.96.37 1.29.48.54.17 1.03.15 1.42.09.43-.07 1.34-.55 1.53-1.08.19-.53.19-.98.13-1.08-.05-.09-.2-.15-.42-.26Z"/></svg>`
    };
    return icons[name] || '';
  }

  function buildMobileBottomNav() {
    if (document.getElementById('KSMobileBottomNav')) return;
    const nav = document.createElement('nav');
    nav.id = 'KSMobileBottomNav';
    nav.className = 'ks-mobile-nav';
    nav.setAttribute('aria-label', 'Quick navigation');
    nav.innerHTML = `
      <a class="ks-mobile-nav__item" href="/">${iconSvg('home')}<span>Home</span></a>
      <a class="ks-mobile-nav__item" href="/collections">${iconSvg('collections')}<span>Collections</span></a>
      <a class="ks-mobile-nav__item ks-mobile-nav__item--wa" href="${KS_WA}" target="_blank" rel="noopener noreferrer" aria-label="Chat with KS Textiles on WhatsApp"><span class="ks-mobile-nav__wa-icon">${iconSvg('whatsapp')}</span><span>WhatsApp</span></a>
      <a class="ks-mobile-nav__item" href="/account">${iconSvg('account')}<span>Account</span></a>
      <a class="ks-mobile-nav__item" href="/cart">${iconSvg('cart')}<span>Cart</span></a>`;
    document.body.appendChild(nav);
  }

  function initKSHome() {
    buildMobileBottomNav();
    if (!document.body.classList.contains('index-template')) return;

    const editLinks = [
      '/collections/kanjivaram-saree',
      '/collections/all?sort_by=created-descending',
      '/collections/marriage-pattu',
      '/collections/premium-soft-silk-saree'
    ];
    document.querySelectorAll('.ks-edit__card').forEach((card, i) => {
      if (editLinks[i]) card.setAttribute('href', editLinks[i]);
    });

    const priceLinks = [
      '/collections/under-2-000',
      '/collections/2-000-5-000',
      '/collections/5-000-10-000',
      '/collections/10-000-15-000',
      '/collections/above-15-000'
    ];
    document.querySelectorAll('.ks-price-item').forEach((item, i) => {
      if (priceLinks[i]) item.setAttribute('href', priceLinks[i]);
    });

    hideDemoSections();

    const collectionSection = document.querySelector('[id*="collection_list_Pr36qH"]');
    buildCollectionShop(collectionSection);

    const founderSection = document.querySelector('[id*="image_with_text_MgddA8"]');
    const newArrivals = document.getElementById('KSNewArrivals');
    if (newArrivals) {
      if (founderSection && founderSection.parentNode) founderSection.parentNode.insertBefore(newArrivals, founderSection);
      newArrivals.hidden = false;
    }

    if (founderSection) {
      const eyebrow = founderSection.querySelector('.rich-text__subheading, .subheading');
      const heading = founderSection.querySelector('.rich-text__heading, h2');
      const founderText = founderSection.querySelector('.rich-text__text');
      if (eyebrow) eyebrow.textContent = 'ROOTED IN ILAMPILLAI';
      if (heading) heading.textContent = 'From Ilampillai, With an Eye for the Right Saree.';
      if (founderText) {
        founderText.innerHTML = '<p>KS Textiles began in Ilampillai, where sarees are part of everyday life as much as celebration. Karthick and Jegan built KS around a simple idea: make beautiful South Indian sarees easier to discover online, without losing the care and personal guidance of buying from a trusted textile shop.</p><p>Every collection is selected for how it looks, feels and drapes in real life — from richly detailed Kanchi styles to lightweight borderless soft silks.</p>';
      }
      const founderContent = founderSection.querySelector('.image-with-text__content') || founderText?.parentElement;
      if (founderContent && !founderContent.querySelector('.ks-founder-help')) {
        const help = document.createElement('a');
        help.className = 'btn btn--primary ks-founder-help';
        help.href = KS_WA;
        help.target = '_blank';
        help.rel = 'noopener noreferrer';
        help.textContent = 'Chat with us on WhatsApp';
        founderContent.appendChild(help);
      }
    }

    restoreOldReviews();

    const faq = document.querySelector('[id*="collapsible_tabs_KNKLiF"]');
    if (faq) {
      const faqHeading = faq.querySelector('.rich-text__heading');
      const faqText = faq.querySelector('.rich-text__text');
      if (faqHeading) faqHeading.textContent = 'Questions? We’re Here to Help';
      if (faqText) faqText.innerHTML = '<p>Everything you need to know about ordering, delivery, returns and our saree collections.</p>';
      buildAssistedShopping(faq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKSHome, { once: true });
  } else {
    initKSHome();
  }
})();
